import React, { useEffect } from "react";
import Image from "next/image";
import AOS from "aos";
import "aos/dist/aos.css";
import Data from "data/topCategories";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

// CounsellingBody Component
const CounsellingBody = () => {

  // FAST AOS INIT
  useEffect(() => {
    AOS.init({
      duration: 400, // was 1000
      offset: 100,   // faster trigger
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);

  const handleRedirect = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section
      className="layout-pt-md layout-pb-md bg-beige-1 flex flex-col items-center"
      data-aos="fade-up"
    >
      <div className="container flex flex-col items-center">

        {/* TITLE */}
        <div className="row justify-center text-center w-full">
          <div
            className="col-auto"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            <div className="sectionTitle">
              <h2 className="sectionTitle__title">
                All NEET{" "}
                <span className="predict-highlight"> Counselling Bodies</span>
              </h2>
              <p className="sectionTitle__text" style={{ fontSize: "15px" }}>
                NEET Counselling Bodies in India (MCC & State Quotas)
              </p>
            </div>
          </div>
        </div>

        {/* CARDS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 pt-[40px] w-full">
          {Data.slice().map((body, index) => {
            const cleanUrl = body.OfficialWebsite.split('?')[0];
            return (
              <div
                key={index}
                data-aos="flip-left"
                data-aos-delay={index * 80} // was 150
                className="flex justify-center"
              >
                <Link
                  href={cleanUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="categoryCard flex flex-col items-center p-6 bg-white shadow-md rounded-lg transition-transform transform hover:scale-105 h-auto w-[400px]"
                >
                  {/* IMAGE */}
                  <div
                    className="mb-4 flex items-center justify-center h-24"
                    data-aos="zoom-in"
                    data-aos-delay={index * 100} // was 180
                  >
                    {body.logo.startsWith("http") ? (
                      <Image
                        src={body.logo}
                        alt={`${body.Counselling} logo`}
                        width={80}
                        height={80}
                        loading="lazy"
                        style={{ objectFit: "contain" }}
                        unoptimized
                      />
                    ) : (
                      <Image
                        src={body.logo}
                        alt={`${body.Counselling} logo`}
                        width={80}
                        height={80}
                        loading="lazy"
                        style={{ objectFit: "contain" }}
                      />
                    )}
                  </div>
                  {/* TITLE */}
                  <h3 className="text-center text-lg font-medium text-gray-800">
                    {body.Counselling}
                  </h3>
                </Link>
              </div>
            );
          })}
        </div>
      </div>

      {/* BUTTON */}
      <div className="row justify-center pt-5 lg:pt-[40px]">
        <div className="col-auto" data-aos="fade-up" data-aos-delay="180">
          <Link
            href="/counselling"
            className="button -icon -orange-1 text-white"
            style={{
              display: "inline-block",
              backgroundColor: "rgb(255,146,69)",
              color: "#fff",
              borderRadius: "25px",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "16px",
              padding: "12px 24px",
            }}
          >
            View All
            <FontAwesomeIcon
              icon={faArrowUpRightFromSquare}
              className="ml-2 text-sm"
            />
          </Link>
        </div>
      </div>

    </section>
  );
};

export default CounsellingBody;
